import { Dayjs } from "dayjs";
import { IWeek } from "lobbie";
import CalendarDay from "src/components/shared/calendar/CalendarDay";

interface IProps {
    today: Dayjs;
    month: number;
    week: IWeek;
    selectedDate: Dayjs | null | undefined;
    selectDay: (date: Dayjs) => void;
    getAvailableDay: (day: Dayjs) => boolean;
    getScheduledDay: (day: Dayjs) => boolean;
    isPatientScheduling: boolean;
}

const CalendarWeek: React.FC<IProps> = ({ week, ...props }) => {
    return (
        <tr className={"cal-week"}>
            {week.days.map((day: Dayjs | null, index: number) => {
                return (
                    <CalendarDay
                        key={`calendar-day-${day?.date()}-${index}`}
                        day={day}
                        index={index}
                        {...props}
                    />
                );
            })}
        </tr>
    );
};

export default CalendarWeek;
